module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_6-81681644d91b7719908d8ad2d33fa4ea.jpg";